import StoryRiverView from 'src/components/StoryRiverView'
import { useSelector } from 'react-redux'
import { getViewByName } from 'src/features/views/ViewsSelector'
import useViewProps from 'src/hooks/useViewProps'

const RelatedNews = ({ id }) => {
  const title = 'Related News'
  const view = useSelector(getViewByName('related news')) || null
  const { viewsError, viewsLoading, handleViewMoreClick } = useViewProps()

  return (
    <StoryRiverView
      view={view}
      viewsError={viewsError}
      viewsLoading={viewsLoading}
      handleViewMoreClick={() => handleViewMoreClick('story', title)}
      title={title}
      viewMore={{
        to: `/river/related-news/${id}`,
        show: true,
        handleMore: title
      }}
      showTeaser={false}
      tagsClickable={true}
    />
  )
}

export default RelatedNews
